import utils from '../utils.js';
import store from '../../store/store.js';
import $http from "@/plugins/axios";
import $const from '../../utils/const';

export default {
    handler_message (msgData, channel) {
        if (channel) {
            let msg = {};
            // msg content
            msg.type = msgData.type;
            msg.created_time = msgData.created_time;
            msg.session_id = msgData.session_id;
            msg.first_session = msgData.first_session;
            msg.supporter = typeof msgData.supporter === "object"? JSON.stringify(msgData.supporter) : msgData.supporter;
            msg.sender_type = msgData.sender_type;
            msg.source = msgData.source;
            msg.status = msgData.status;
            msg.react_icon = msgData.react_icon;
            if (msgData.error_message) {
                msg.error_message = msgData.error_message;
            } else {
                msg.error_message = "";
            }
            if (msg.type === 'payload') {
                if (msgData.content.text === 'get_started') {
                    msg.content = {
                        text: '[User starts the conversation]' //'<span style="font-style: italic">[User starts the conversation]</span>'
                    }
                } else {
                    let split = msgData.content.text.split('#');
                    // fix with message is elastic search (start with es# + payload)
                    if (msgData.content.text.indexOf('es#') === 0) {
                        // is suggestion
                        msg.content = {
                            text: split.length === 4 ? "[ " + split[3] + " ]" : "[ " + split[1] + " ]"
                        }
                    } else {
                        msg.content = {
                            text: split.length === 3 ? "[ " + split[2] + " ]" : "[ " + split[0] + " ]"
                        }
                    }

                }
            } else {
                msg.content = msgData.content;
            }
            if (msg.type === 'file' && channel === 'zalo' && msg.content) {
                let contentObj = typeof msg.content === 'string' ? JSON.parse(msg.content) : msg.content;
                if (contentObj.url) {
                    contentObj.url = 'https://stb-chatbot.fpt.ai/viewfile?url=' + contentObj.url;
                    msg.content = JSON.stringify(contentObj);
                }
            }

            if (!msgData._id) {
                msg.id = "[ls_render]" + utils.render_random_id();
            } else {
                msg.id = msgData._id;
            }

            if (msgData.source && msgData.source === "user") {
                msg.source = "user";
            }

            return msg;
        } else {
            return null
        }
    },

    send_message_to_socket (type, senderId, senderName, botCode, channel, content, jwToken, source=null, supporter) {
        // console.log(store)
        // send to socket
        let data_msg = {
            "channel": channel,
            "sender_id": senderId,
            "sender_name": senderName,
            "bot_code": botCode,
            "jw_token": jwToken,
            "message": {
                "type": type,
                "content": content,
                "source": source
            },
            supporter: supporter
        };

        store.state.scClient.emit('admin_send_message', data_msg)

        // handler message to each channel if not livechat - TODO
    },
    removeChar(str) {
        str = str.toLowerCase();
        str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
        str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
        str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
        str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
        str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
        str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
        str = str.replace(/đ/g, "d");
        str = str.replace(/\s/g, "-")
        return str;
    },

    async send_file_to_customer (botCode, senderId, channel, fileId, file, callback) {
        let url = $const.ENV.VUE_APP_BASE_API_MESSENGER +  '/live-support/conversation-send-file/' + botCode + '/c/' + channel + '/s/' + senderId + '/f/' + fileId + '/';
        let formData = new FormData();
        let file_name = this.removeChar(file.name)
        formData.append('attachment', file, file_name);

        await $http.post(url, formData).then(() => {
            callback(true);
        }).catch(() => {
            callback(false);
        })
    },

    resend_message(botCode, senderId, chatLogId) {
        return $http.put(`/live-support/resend-chatlog/${botCode}/${senderId}/${chatLogId}/`)
    },
}
